import { useIntl } from "react-intl";

import { ReactComponent as CheckCircleGreen } from "assets/images/iconsV2/check-circle-green.svg";
import Badge from "components/v2/Badge/Badge";

import "./ValidationSuccessBadge.scss";

export default function ValidationSuccessBadge() {
  const intl = useIntl();

  return (
    <Badge
      type="category-badge"
      size="sm"
      color="success"
      variant="icon-leading"
      icon={<CheckCircleGreen className="rfv2-validation-success-badge__icon" />}
      label={intl.formatMessage({
        id: "request-form.validation.sectionCompleted",
        defaultMessage: "Completed",
      })}
    />
  );
}
